<template>
  <div class="sw__invitacion mt-privacidad">
    <v-icon>mdi-shield-account-outline</v-icon>
    <p v-if="destino">
      {{ t('minotaria, de Unidata, pone en contacto a particulares con notarías. Sus datos se comunicarán a') }}
      <strong>{{ destino.nombre }}</strong>{{ t(', que será la responsable de tratarlos para atender su encargo.') }}
    </p>
    <p v-else>
      {{ t('minotaria, de Unidata, pone en contacto a particulares con notarías. Como no ha elegido notaría, sus datos se comunicarán a la notaría que le asignemos, que será la responsable de tratarlos para atender su encargo.') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { t } from '../../composables/solicitudTextos'
import { useSolicitudWeb } from '../../composables/useSolicitudWeb'
const { destino } = useSolicitudWeb()
</script>
